import { API_URLs } from "../../../utilities/API_URLs";
import { Http } from "../../../utilities/axios/http";

export class TransportOrderService {
  static getAllTransport = async (params: any) => {
    try {
      return await Http.get(API_URLs.transports.get, params);
    } catch (error) {
      return error;
    }
  };
  static getOneTransport = async (id: number) => {
    try {
      return await Http.getOne(API_URLs.transports.getOne, id);
    } catch (error) {
      return error;
    }
  };
  static createTransport = async (data: any) => {
    try {
      return await Http.post(API_URLs.transports.create, data);
    } catch (error) {
      return error;
    }
  };

  static updateTransport = async (data: any) => {
    try {
      return await Http.patch(API_URLs.transports.update, data);
    } catch (error) {
      return error;
    }
  };

  static getSelectState = async (params?: any) => {
    try {
      return await Http.get(API_URLs.transports.selectState, params);
    } catch (error) {
      return error;
    }
  };

  static assignOTToTruck = async (id: number, data: any) => {
    try {
      return await Http.patchCustom(API_URLs.transports.truckAssign(id), data);
    } catch (error) {
      return error;
    }
  };
}
